// extracted by mini-css-extract-plugin
export default {"container":"Link_container__5oldl"};